import { render } from "./HealthMain.vue?vue&type=template&id=617b217d&scoped=true"
import script from "./HealthMain.vue?vue&type=script&lang=js"
export * from "./HealthMain.vue?vue&type=script&lang=js"

import "./HealthMain.vue?vue&type=style&index=0&id=617b217d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617b217d"]])

export default __exports__